"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.default = exports.BUTTON_TYPE_TERTIARY = exports.BUTTON_TYPE_SECONDARY = exports.BUTTON_TYPE_PRIMARY = exports.BUTTON_TYPE_PLAIN = exports.BUTTON_TYPE_INACTIVE = exports.BUTTON_TYPE_ALERT = exports.BUTTON_SIZE_SMALL = exports.BUTTON_SIZE_REGULAR = exports.BUTTON_SIZE_MEDIUM = exports.BUTTON_SIZE_LARGE = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));
var _react = _interopRequireDefault(require("react"));
var T = _interopRequireWildcard(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _AutoIntl = _interopRequireDefault(require("./AutoIntl"));
var _constants = require("../../constants");
var _AuAnalytics = _interopRequireDefault(require("../../utils/AuAnalytics"));
var _context;
function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var styles = {
  "large": "au_button-module__large___kqJ27",
  "regular": "au_button-module__regular___VA1wF",
  "medium": "au_button-module__medium___lAZH5",
  "small": "au_button-module__small___QokIy",
  "tertiary": "au_button-module__tertiary___iyEYo",
  "primary": "au_button-module__primary___Pb2hK",
  "secondary": "au_button-module__secondary___fi5EX",
  "alert": "au_button-module__alert___Oy40t",
  "inactive": "au_button-module__inactive___zSbo3",
  "plain": "au_button-module__plain___btyM0"
}; //exporting styles for vanilla JS buttons
exports.styles = styles;
const BUTTON_TYPE_PRIMARY = 'primary';
exports.BUTTON_TYPE_PRIMARY = BUTTON_TYPE_PRIMARY;
const BUTTON_TYPE_SECONDARY = 'secondary';
exports.BUTTON_TYPE_SECONDARY = BUTTON_TYPE_SECONDARY;
const BUTTON_TYPE_TERTIARY = 'tertiary';
exports.BUTTON_TYPE_TERTIARY = BUTTON_TYPE_TERTIARY;
const BUTTON_TYPE_PLAIN = 'plain';
exports.BUTTON_TYPE_PLAIN = BUTTON_TYPE_PLAIN;
const BUTTON_TYPE_ALERT = 'alert';
exports.BUTTON_TYPE_ALERT = BUTTON_TYPE_ALERT;
const BUTTON_TYPE_INACTIVE = 'inactive';
exports.BUTTON_TYPE_INACTIVE = BUTTON_TYPE_INACTIVE;
const BUTTON_SIZE_SMALL = 'small';
exports.BUTTON_SIZE_SMALL = BUTTON_SIZE_SMALL;
const BUTTON_SIZE_MEDIUM = 'medium';
exports.BUTTON_SIZE_MEDIUM = BUTTON_SIZE_MEDIUM;
const BUTTON_SIZE_REGULAR = 'regular';
exports.BUTTON_SIZE_REGULAR = BUTTON_SIZE_REGULAR;
const BUTTON_SIZE_LARGE = 'large';

/**
 * Creates HTML button element
 * @param {string}   type               Button type. One of: primary, secondary, plain.
 * @param {string}   size               Size type passed along as the button's class modifier
 * @param {string}   className          Button class name.
 * @param {boolean}  disabled           Enables or Disables button interactions.
 * @param {string}   displayId          FormattedMessage id to be used as a button caption.
 * @param {string}   displayString      Button caption.
 * @param {function} onClick            Button onClick handler.
 */
exports.BUTTON_SIZE_LARGE = BUTTON_SIZE_LARGE;
class AuButton extends _react.default.PureComponent {
  static sizes = [BUTTON_SIZE_SMALL, BUTTON_SIZE_MEDIUM, BUTTON_SIZE_REGULAR, BUTTON_SIZE_LARGE];
  static types = [BUTTON_TYPE_PRIMARY, BUTTON_TYPE_SECONDARY, BUTTON_TYPE_TERTIARY, BUTTON_TYPE_PLAIN, BUTTON_TYPE_ALERT, BUTTON_TYPE_INACTIVE];
  static propTypes = {
    type: T.oneOf(AuButton.types),
    size: T.oneOf(AuButton.sizes),
    className: T.string,
    disabled: T.bool,
    displayId: T.string,
    displayString: T.string,
    onClick: T.func,
    tracking: T.shape({
      category: T.string,
      action: T.string,
      page: T.string
    })
  };
  static defaultProps = {
    type: BUTTON_TYPE_TERTIARY,
    size: BUTTON_SIZE_REGULAR,
    disabled: false,
    onClick: _constants.NOOP
  };
  handleOnClick = (0, _bind.default)(_context = this.handleOnClick).call(_context, this);
  handleOnClick(event) {
    const {
      tracking,
      onClick
    } = this.props;
    if (tracking) {
      _AuAnalytics.default.trackEvent({
        category: tracking.element || 'Button',
        action: tracking.action,
        label: tracking.page
      });
    }
    return onClick(event);
  }
  getFilteredProps(props) {
    const {
      size,
      disabled,
      className
    } = props;
    const type = disabled ? BUTTON_TYPE_INACTIVE : props.type;
    const filteredProps = {
      ...props
    };
    // do not propagete "type" attribute to the real element since it will
    // contain non-standard value (for example for the <button> element).
    delete filteredProps['type'];
    delete filteredProps['size'];
    delete filteredProps['tracking'];
    // do not pass children to itself
    delete filteredProps['children'];
    filteredProps['className'] = (0, _classnames.default)(styles[size], styles[type], className);
    return filteredProps;
  }
  renderContent(props) {
    const filteredProps = this.getFilteredProps({
      ...props,
      onClick: this.handleOnClick
    });
    const {
      children
    } = props;
    return /*#__PURE__*/_react.default.createElement(_AutoIntl.default, (0, _extends2.default)({}, filteredProps, {
      tag: "button"
    }), children);
  }
  render() {
    return this.renderContent(this.props);
  }
}
exports.default = AuButton;